import React, { createContext, useState, useContext } from 'react';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';

export const UserRecordsContext = createContext({});

export function UserRecordsContextProvider({ children }) {
  const [userRecords, setLocalUserRecords] = useState({
    name: '',
    email: ''
  });

  function setUserRecords(updatedUserRecords) {
    if (!isEqual(userRecords, updatedUserRecords))
      setLocalUserRecords(updatedUserRecords);
  }

  return (
    <UserRecordsContext.Provider value={{ userRecords, setUserRecords }}>
      {children}
    </UserRecordsContext.Provider>
  );
}

UserRecordsContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useUserRecords = () => {
  return useContext(UserRecordsContext);
};
